"use strict";
(self["__LOADABLE_LOADED_CHUNKS__"] = self["__LOADABLE_LOADED_CHUNKS__"] || []).push([[6113],{

/***/ 49952:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   Z: () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* unused harmony export styleMap */
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(97458);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(52983);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(78364);
/* harmony import */ var intl__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(927);
/* harmony import */ var components_dataDisplay__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(90234);
/* harmony import */ var components_inputs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(97127);






const styleMap = {
    "gold-50": {
        base: "text-gold-50",
        disabled: "text-gray-50",
        hover: "desktop-hover:text-gold-30"
    },
    "gold-30": {
        base: "text-gold-30",
        disabled: "text-gray-30",
        hover: "desktop-hover:text-pink"
    },
    "black": {
        base: "text-black",
        disabled: "text-gray-50",
        hover: "desktop-hover:text-gray-80"
    },
    "white": {
        base: "text-white",
        disabled: "text-gray-30",
        hover: null
    }
};
const ActionButton = (props)=>{
    const { children, className, title, loading, disabled, style = "gold-50", wordBreak = false, ...rest } = props;
    const classes = styleMap[style];
    const titleClassName = (0,classnames__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)("text-left uppercase", !wordBreak && "whitespace-nowrap");
    const buttonClassName = (0,classnames__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(className, "inline-block select-none text-t5", disabled ? "cursor-not-allowed" : "cursor-pointer", classes.base, disabled ? classes.disabled : classes.hover);
    const buttonBaseProps = {
        className: buttonClassName,
        loading,
        disabled,
        ...rest
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_inputs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
        ...buttonBaseProps,
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("span", {
            className: "flex items-center justify-between",
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                    className: titleClassName,
                    children: title ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(intl__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
                        value: title
                    }) : children
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_dataDisplay__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .ZP, {
                    className: "ml-14 flex-none",
                    name: "other/long-arrow-right"
                })
            ]
        })
    });
};
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (ActionButton);


/***/ }),

/***/ 30468:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  Z: () => (/* binding */ Button_Button)
});

// EXTERNAL MODULE: ../../node_modules/.pnpm/react@18.2.0/node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(97458);
// EXTERNAL MODULE: ../../node_modules/.pnpm/react@18.2.0/node_modules/react/index.js
var react = __webpack_require__(52983);
// EXTERNAL MODULE: ../../node_modules/.pnpm/clsx@2.1.0/node_modules/clsx/dist/clsx.mjs
var clsx = __webpack_require__(78364);
// EXTERNAL MODULE: ./src/components/inputs/ButtonBase/ButtonBase.tsx
var ButtonBase = __webpack_require__(97127);
;// CONCATENATED MODULE: ./src/components/inputs/Button/ButtonStyle/ButtonStyle.module.css
// extracted by mini-css-extract-plugin
/* harmony default export */ const ButtonStyle_module = ({"button":"POxfBC","disabled":"MrxE_f","size-56":"isKqCl","size-48":"gJS5O8","size-38":"W1AtU6","size-26":"MJ0OsF","loading":"QmYn5A","styled":"V8zDV4","primary":"G1Xuei","secondary":"QM0TUv","tertiary":"nBelHK","gold-30":"c6Ov1Y","gold-30-secondary":"X7LgNA","red":"iCejWF"});
;// CONCATENATED MODULE: ./src/components/inputs/Button/ButtonStyle/ButtonStyle.tsx





const sizes = (/* unused pure expression or super */ null && ([
    26,
    38,
    48,
    56
]));
// ATTN this is constants that discussed with designers! don't change it w/o the purpose!
const widthToClassNameMap = {
    120: "min-w-[120rem]",
    164: "min-w-[164rem]",
    200: "min-w-[200rem]",
    240: "min-w-[240rem]",
    280: "min-w-[280rem]",
    320: "min-w-[320rem]"
};
const styles = (/* unused pure expression or super */ null && ([
    "primary",
    "secondary",
    "tertiary",
    "gold-30",
    "gold-30-secondary",
    "red"
]));
const ButtonStyle = /*#__PURE__*/ (0,react.forwardRef)((props, ref)=>{
    const { // basic
    children, className, afterNode, // modifiers
    size, style = "primary", noPadding, width, fullWidth, fullWidthOnMobile, disabled, loading, ...rest } = props;
    // Classes ----------------------- /
    const padding = noPadding ? null : fullWidth ? "px-8" : "px-32";
    const nodeClassName = (0,clsx/* default */.Z)(ButtonStyle_module.button, className, "button", padding, ButtonStyle_module[style], ButtonStyle_module[`size-${size}`], widthToClassNameMap[width], {
        "w-full": fullWidth,
        "mobile:w-full mobile:px-8": fullWidthOnMobile,
        [ButtonStyle_module.styled]: style,
        [ButtonStyle_module.disabled]: disabled,
        [ButtonStyle_module.loading]: loading
    });
    const nodeProps = {
        className: nodeClassName,
        disabled,
        loading,
        ...rest
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(ButtonBase/* default */.Z, {
        ref: ref,
        ...nodeProps,
        children: [
            children,
            afterNode
        ]
    });
});
/* harmony default export */ const ButtonStyle_ButtonStyle = (ButtonStyle);

// EXTERNAL MODULE: ./local_modules/intl/Message.tsx + 1 modules
var Message = __webpack_require__(927);
// EXTERNAL MODULE: ./src/components/dataDisplay/Icon/Icon.tsx + 112 modules
var Icon = __webpack_require__(90234);
// EXTERNAL MODULE: ./src/components/inputs/Button/messages.ts
var messages = __webpack_require__(34212);
;// CONCATENATED MODULE: ./src/components/inputs/Button/ButtonContent/ButtonContent.tsx





const ButtonContent = (props)=>{
    const { children, title, inlineIcon, html, loading, loadingMessage } = props;
    if (loading) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(Message/* default */.Z, {
            value: loadingMessage || messages/* default */.Z.loading
        });
    }
    let inlineIconClassName = "ml-4";
    if (inlineIcon === "32/arrow-right") {
        inlineIconClassName = null;
    } else if (inlineIcon === "36/video-white-arrow") {
        inlineIconClassName = "ml-12";
    }
    if (title) {
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Message/* default */.Z, {
                    value: title,
                    html: html
                }),
                Boolean(inlineIcon) && /*#__PURE__*/ (0,jsx_runtime.jsx)(Icon/* default */.ZP, {
                    className: inlineIconClassName,
                    name: inlineIcon
                })
            ]
        });
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: children
    });
};
/* harmony default export */ const ButtonContent_ButtonContent = (ButtonContent);

;// CONCATENATED MODULE: ./src/components/inputs/Button/ButtonWithIcons/ButtonIcon/ButtonIcon.tsx



const ButtonIcon = (param)=>{
    let { name } = param;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
        className: "relative h-full",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
                className: "h-full w-auto",
                width: 2,
                height: 2,
                viewBox: "0 0 2 2"
            }),
            Boolean(name) && /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                className: "absolute left-0 top-0 flex h-full w-full items-center justify-center",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Icon/* default */.ZP, {
                    name: name
                })
            })
        ]
    });
};
/* harmony default export */ const ButtonIcon_ButtonIcon = (ButtonIcon);

;// CONCATENATED MODULE: ./src/components/inputs/Button/ButtonWithIcons/ButtonWithIcons.tsx





const ButtonWithIcons = /*#__PURE__*/ (0,react.forwardRef)((props, ref)=>{
    const { children, title, size, loading, loadingMessage, fullWidth, fullWidthOnMobile, leftIcon, rightIcon, ...rest } = props;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(ButtonStyle_ButtonStyle, {
        ref: ref,
        size: size,
        loading: loading,
        fullWidth: fullWidth,
        fullWidthOnMobile: fullWidthOnMobile,
        noPadding: true,
        ...rest,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "flex h-full w-full items-center justify-between",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(ButtonIcon_ButtonIcon, {
                    name: leftIcon
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(ButtonContent_ButtonContent, {
                    title: title,
                    loading: loading,
                    loadingMessage: loadingMessage,
                    children: children
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(ButtonIcon_ButtonIcon, {
                    name: rightIcon
                })
            ]
        })
    });
});
/* harmony default export */ const ButtonWithIcons_ButtonWithIcons = (ButtonWithIcons);

;// CONCATENATED MODULE: ./src/components/inputs/Button/SimpleButton/SimpleButton.tsx




const SimpleButton = /*#__PURE__*/ (0,react.forwardRef)((props, ref)=>{
    const { children, title, inlineIcon, style, html, loading, loadingMessage, ...rest } = props;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(ButtonStyle_ButtonStyle, {
        ref: ref,
        style: style,
        loading: loading,
        ...rest,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ButtonContent_ButtonContent, {
            title: title,
            inlineIcon: inlineIcon,
            loading: loading,
            loadingMessage: loadingMessage,
            html: html,
            children: children
        })
    });
});
/* harmony default export */ const SimpleButton_SimpleButton = (SimpleButton);

;// CONCATENATED MODULE: ./src/components/inputs/Button/Button.tsx




const Button = /*#__PURE__*/ (0,react.forwardRef)((props, ref)=>{
    const { leftIcon, rightIcon, ...rest } = props;
    if (leftIcon || rightIcon) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(ButtonWithIcons_ButtonWithIcons, {
            ref: ref,
            ...props
        });
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(SimpleButton_SimpleButton, {
        ref: ref,
        ...rest
    });
});
/* harmony default export */ const Button_Button = (Button);


/***/ }),

/***/ 34212:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   Z: () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = ({
    ok: {
        en: "Ok"
    },
    back: {
        en: "Back"
    },
    next: {
        en: "Next"
    },
    choose: {
        en: "Choose"
    },
    chooseNow: {
        en: "Choose now"
    },
    chooseFragrance: {
        en: "Choose your fragrance"
    },
    accept: {
        en: "Accept"
    },
    cancel: {
        en: "Cancel"
    },
    decline: {
        en: "Decline"
    },
    confirm: {
        en: "Confirm"
    },
    login: {
        en: "Log in"
    },
    finish: {
        en: "Finish"
    },
    reject: {
        en: "Reject"
    },
    remove: {
        en: "Remove"
    },
    save: {
        en: "Save"
    },
    submit: {
        en: "Submit"
    },
    edit: {
        en: "Edit"
    },
    subscribe: {
        en: "Subscribe"
    },
    subscribeForPrice: {
        en: "Subscribe for {price}"
    },
    subscribeForPriceWithDiscount: {
        en: 'Subscribe for {priceWithDiscount} <s aria-label="reduced from">{price}</s>'
    },
    subscribeNow: {
        en: "Subscribe now"
    },
    resubscribe: {
        en: "Resubscribe"
    },
    resubscribeNow: {
        en: "Resubscribe now"
    },
    unsubscribe: {
        en: "Unsubscribe"
    },
    unpause: {
        en: "Unpause"
    },
    upgrade: {
        en: "Upgrade"
    },
    upgradeNow: {
        en: "Upgrade now"
    },
    downgrade: {
        en: "Downgrade"
    },
    close: {
        en: "Close"
    },
    orderNow: {
        en: "Order now"
    },
    shopNow: {
        en: "Shop now"
    },
    showMore: {
        en: "Show more"
    },
    buyNow: {
        en: "Buy now"
    },
    gotIt: {
        en: "Got it!"
    },
    redeem: {
        en: "Redeem"
    },
    redeemGift: {
        en: "Redeem gift"
    },
    pay: {
        en: "Pay"
    },
    payWithTotal: {
        en: "Pay {total}"
    },
    getStarted: {
        en: "Get started",
        es: "Comienza ahora"
    },
    resetPassword: {
        en: "Reset password"
    },
    update: {
        en: "Update"
    },
    continue: {
        en: "Continue"
    },
    continueCancellation: {
        en: "Continue cancellation"
    },
    neverMind: {
        en: "Never mind"
    },
    reply: {
        en: "Reply"
    },
    send: {
        en: "Send"
    },
    imIn: {
        en: "i'm in"
    },
    checkout: {
        en: "Checkout"
    },
    checkoutNow: {
        en: "Checkout now"
    },
    buyInOneClick: {
        en: "Buy in one click"
    },
    learnMore: {
        en: "Learn more"
    },
    loadMore: {
        en: "Load more"
    },
    maybeLater: {
        en: "Maybe later"
    },
    viewMoreFragrances: {
        en: "View more fragrances"
    },
    bestsellers: {
        en: "Browse best sellers"
    },
    details: {
        en: "Details"
    },
    keepIt: {
        en: "Keep it"
    },
    iAmSure: {
        en: "I’m sure"
    },
    loading: {
        en: "Loading..."
    },
    submitting: {
        en: "Submitting..."
    },
    addToQueue: {
        en: "Add to queue"
    },
    addToCart: {
        en: "Add to cart"
    },
    soldOut: {
        en: "Sold out"
    },
    added: {
        en: "Added"
    },
    tryIt: {
        en: "Try it"
    },
    trackIt: {
        en: "Track it"
    },
    browse: {
        en: "Browse"
    },
    browseOurGallery: {
        en: "Browse our gallery"
    },
    whatsThis: {
        en: "What`s this?"
    },
    outOfStock: {
        en: "Out of stock"
    },
    viewAll: {
        en: "View all"
    },
    playVideo: {
        en: "Play video"
    },
    discoverDrift: {
        en: "Discover drift"
    }
});


/***/ }),

/***/ 97127:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   Z: () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(52983);
/* harmony import */ var helpers_getters__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(614);
/* harmony import */ var components_navigation__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(45881);



const ButtonBase = /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_0__.forwardRef)((props, ref)=>{
    const { // basic
    children, id, className, // modifiers
    disabled, loading, // links
    to, toTab, href, onClick, onMouseOver, // misc
    tag = "button", type = "button", ...rest } = props;
    const handleClick = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)((event)=>{
        if (disabled || loading) {
            event.preventDefault();
            return;
        }
        if (typeof onClick === "function") {
            onClick(event);
        }
    }, [
        onClick,
        disabled,
        loading
    ]);
    let node = tag;
    const htmlAttrs = (0,helpers_getters__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(rest);
    let nodeProps = {
        ref,
        className,
        id,
        onClick: handleClick,
        onMouseOver,
        "aria-disabled": disabled || loading,
        "aria-busy": loading,
        ...htmlAttrs
    };
    if (to || toTab || href) {
        node = components_navigation__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z;
        nodeProps = {
            ...nodeProps,
            disabled,
            to,
            href,
            toTab
        };
    } else if (tag === "button" || tag === "input") {
        nodeProps.disabled = disabled;
        nodeProps.type = type;
    } else {
        nodeProps.role = "button";
    }
    return /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(node, nodeProps, children);
});
ButtonBase.displayName = "ButtonBase";
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (ButtonBase);


/***/ }),

/***/ 90984:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   Z: () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(97458);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(52983);
/* harmony import */ var formular__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(29987);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(78364);
/* harmony import */ var components_dataDisplay__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(60798);
/* harmony import */ var components_dataDisplay__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(78565);
/* harmony import */ var _InputError_InputError__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(1324);






const Checkbox = (props)=>{
    const { children, className, field, label, labelStyle = "p2", style, value, disabled, fullWidth, errorClassName = "mt-4", errorText, customError, onClick, "aria-label": ariaLabel, "data-testid": dataTestId } = props;
    const state = (0,formular__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(field);
    const isCheckboxGroup = Array.isArray(state.value);
    const isChecked = isCheckboxGroup ? state.value.includes(value) : state.value;
    const rootClassName = (0,classnames__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)("inline-flex cursor-pointer select-none items-start text-left align-top", className, {
        "cursor-not-allowed": disabled,
        "w-full": fullWidth
    });
    const handleClick = (0,react__WEBPACK_IMPORTED_MODULE_1__.useCallback)(()=>{
        // checkbox group
        if (Array.isArray(state.value)) {
            if (state.value.includes(value)) {
                field.set(state.value.filter((v)=>v !== value));
            } else {
                field.set([
                    ...state.value,
                    value
                ]);
            }
        } else {
            field.set(!state.value);
        }
        if (typeof onClick === "function") {
            onClick();
        }
    }, [
        field,
        state.value,
        value,
        onClick
    ]);
    const error = customError ? customError : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_InputError_InputError__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
        className: errorClassName,
        message: errorText || state.error,
        "data-testid": `${dataTestId}Error`
    });
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("button", {
                className: rootClassName,
                type: "button",
                role: "checkbox",
                disabled: disabled,
                "aria-label": ariaLabel,
                "aria-checked": value,
                "data-testid": dataTestId,
                onClick: handleClick,
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_dataDisplay__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
                        style: style,
                        active: isChecked,
                        disabled: disabled,
                        error: Boolean(state.error)
                    }),
                    Boolean(label) && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_dataDisplay__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .ZP, {
                        className: "ml-16",
                        message: label,
                        style: labelStyle,
                        color: disabled ? "gray-80" : "black",
                        html: true
                    }),
                    children
                ]
            }),
            Boolean(state.error) && error
        ]
    });
};
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (Checkbox);


/***/ }),

/***/ 42418:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   Z: () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(97458);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(52983);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(78364);
/* harmony import */ var formular__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(29987);
/* harmony import */ var _dataDisplay_Chip_Chip__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(69960);





const ChipSelect = (props)=>{
    const { className, itemClassName, color, labelStyle, field, onChange, options, "data-testid": dataTestId = "chip" } = props;
    const { value } = (0,formular__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(field);
    const handleChange = (0,react__WEBPACK_IMPORTED_MODULE_1__.useCallback)((value)=>()=>{
            field.set(value);
            if (typeof onChange === "function") {
                onChange(value);
            }
        }, [
        field,
        onChange
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: (0,classnames__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(className, "flex flex-wrap gap-8"),
        "data-testid": dataTestId,
        children: options.map((option)=>{
            const { label, value: optionValue } = option;
            const active = value === optionValue;
            const handleClick = handleChange(optionValue);
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_dataDisplay_Chip_Chip__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .ZP, {
                className: itemClassName,
                label: label,
                labelStyle: labelStyle,
                active: active,
                color: color,
                onClick: handleClick,
                "data-testid": `${dataTestId}-option-${optionValue}`
            }, optionValue.toString());
        })
    });
};
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (/*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1__.memo(ChipSelect));


/***/ }),

/***/ 80899:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  Z: () => (/* binding */ CloseIconButton_CloseIconButton)
});

// EXTERNAL MODULE: ../../node_modules/.pnpm/react@18.2.0/node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(97458);
// EXTERNAL MODULE: ../../node_modules/.pnpm/react@18.2.0/node_modules/react/index.js
var react = __webpack_require__(52983);
// EXTERNAL MODULE: ../../node_modules/.pnpm/clsx@2.1.0/node_modules/clsx/dist/clsx.mjs
var clsx = __webpack_require__(78364);
// EXTERNAL MODULE: ./local_modules/intl/useIntl.ts
var useIntl = __webpack_require__(2129);
// EXTERNAL MODULE: ./src/components/dataDisplay/Icon/Icon.tsx + 112 modules
var Icon = __webpack_require__(90234);
;// CONCATENATED MODULE: ./src/components/inputs/CloseIconButton/messages.ts
/* harmony default export */ const messages = ({
    close: {
        en: "Close"
    },
    remove: {
        en: "Remove"
    }
});

;// CONCATENATED MODULE: ./src/components/inputs/CloseIconButton/CloseIconButton.module.css
// extracted by mini-css-extract-plugin
/* harmony default export */ const CloseIconButton_module = ({"button":"FX8Ef_","js-focus-visible":"wUqA8q","focus-visible":"JTk6NB"});
;// CONCATENATED MODULE: ./src/components/inputs/CloseIconButton/CloseIconButton.tsx







const CloseIconButton = (props)=>{
    const { className, withRemoveLabel, icon = "32/close", color, disabled, loading, "aria-label": ariaLabel, "data-testid": dataTestId, onClick } = props;
    const intl = (0,useIntl/* default */.Z)();
    const testId = dataTestId || (withRemoveLabel ? "removeButton" : "closeButton");
    const label = intl.formatMessage(ariaLabel || (withRemoveLabel ? messages.remove : messages.close));
    const handleClick = (event)=>{
        if (loading) {
            return;
        }
        if (typeof onClick === "function") {
            onClick(event);
        }
    };
    // TODO add Icon Size here? - added on 2/5/21 by pavelivanov
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
        className: (0,clsx/* default */.Z)(CloseIconButton_module.button, className),
        type: "button",
        "aria-label": label,
        "aria-busy": loading,
        "data-testid": testId,
        disabled: disabled,
        onClick: handleClick,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Icon/* default */.ZP, {
            name: icon,
            color: color
        })
    });
};
/* harmony default export */ const CloseIconButton_CloseIconButton = (CloseIconButton);


/***/ }),

/***/ 55578:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   Z: () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(97458);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(52983);


// Little helper to handle loading and disable states for form
const Form = (props)=>{
    const { children, loading, disabled, onSubmit, ...rest } = props;
    const handleSubmit = (0,react__WEBPACK_IMPORTED_MODULE_1__.useCallback)((event)=>{
        event.preventDefault();
        if (loading || disabled) {
            return;
        }
        if (typeof onSubmit === "function") {
            onSubmit(event);
        }
    }, [
        loading,
        disabled,
        onSubmit
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("form", {
        ...rest,
        noValidate: true,
        "aria-disabled": disabled,
        "aria-busy": loading,
        onSubmit: handleSubmit,
        children: children
    });
};
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (Form);


/***/ }),

/***/ 26268:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  Z: () => (/* binding */ Input_Input)
});

// UNUSED EXPORTS: sizes

// EXTERNAL MODULE: ../../node_modules/.pnpm/react@18.2.0/node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(97458);
// EXTERNAL MODULE: ../../node_modules/.pnpm/react@18.2.0/node_modules/react/index.js
var react = __webpack_require__(52983);
// EXTERNAL MODULE: ./local_modules/formular/useFieldState.ts
var useFieldState = __webpack_require__(29987);
// EXTERNAL MODULE: ./src/hooks/useCombinedRefs.ts
var useCombinedRefs = __webpack_require__(48245);
// EXTERNAL MODULE: ./src/hooks/useUniqueId.ts
var useUniqueId = __webpack_require__(91327);
// EXTERNAL MODULE: ./local_modules/intl/Message.tsx + 1 modules
var Message = __webpack_require__(927);
// EXTERNAL MODULE: ./src/helpers/validators/index.ts + 1 modules
var validators = __webpack_require__(4894);
// EXTERNAL MODULE: ./src/helpers/getters/getGlobalHtmlAttrs.ts
var getGlobalHtmlAttrs = __webpack_require__(614);
// EXTERNAL MODULE: ./src/helpers/twcx.ts
var twcx = __webpack_require__(19460);
// EXTERNAL MODULE: ./local_modules/intl/useIntl.ts
var useIntl = __webpack_require__(2129);
// EXTERNAL MODULE: ./src/components/dataDisplay/Icon/Icon.tsx + 112 modules
var Icon = __webpack_require__(90234);
// EXTERNAL MODULE: ./src/components/inputs/InputNote/InputNote.tsx
var InputNote = __webpack_require__(53927);
// EXTERNAL MODULE: ./src/components/inputs/InputError/InputError.tsx
var InputError = __webpack_require__(1324);
;// CONCATENATED MODULE: ./src/components/inputs/Input/util/masks.ts
const createMask = (formula)=>{
    const patternArray = formula.split("");
    return (value)=>{
        if (!value) {
            return "";
        }
        let result = "", index = 0;
        for(let i = 0; i < patternArray.length; i++){
            if (index >= value.length) {
                break;
            }
            const symbol = patternArray[i];
            if (symbol === "X" || symbol === value[index]) {
                result += value[index++];
            } else {
                result += symbol;
            }
        }
        return result;
    };
};
const createMaskWithModifiers = (param)=>{
    let { mask, preModify, postModify } = param;
    const applyMask = mask ? createMask(mask) : null;
    return (value)=>{
        let newValue = value;
        if (typeof preModify === "function") {
            newValue = preModify(newValue);
        }
        if (typeof applyMask === "function") {
            newValue = applyMask(newValue);
        }
        if (typeof postModify === "function") {
            newValue = postModify(newValue);
        }
        return newValue;
    };
};
// Mask result - mm/dd/yyyy
const initDateMask = ()=>{
    const preModify = (value)=>value.replace(/\D/g, "");
    const postModify = (value)=>{
        let [month, day, year] = value.split("/");
        if (month && month > 12) {
            month = 12;
        }
        if (day && day > 31) {
            day = 31;
        }
        return [
            month,
            day,
            year
        ].filter(Boolean).join("/");
    };
    return createMaskWithModifiers({
        mask: "XX/XX/XXXX",
        preModify,
        postModify
    });
};
const initPhoneMask = ()=>{
    const preModify = (value)=>value.replace(/\D/g, "");
    return createMaskWithModifiers({
        mask: "+1 XXX XXX XX XX",
        preModify
    });
};
/* harmony default export */ const masks = ({
    date: initDateMask(),
    phone: initPhoneMask()
});

;// CONCATENATED MODULE: ./src/components/inputs/Input/messages.tsx
/* harmony default export */ const messages = ({
    clear: {
        en: "clear"
    }
});

;// CONCATENATED MODULE: ./src/components/inputs/Input/Input.module.css
// extracted by mini-css-extract-plugin
/* harmony default export */ const Input_module = ({"root":"TFXpws","focused":"b1LpCV","input":"q0ziUf","errored":"dtIaW7","label":"cmZek5","label-p2":"eLy06H","label-p4":"UcCe8u","filled":"lKiukK","size-48":"u2MV2e","size-56":"QYJaPh","cross":"Bc9fL8"});
;// CONCATENATED MODULE: ./src/components/inputs/Input/Input.tsx















const sizes = (/* unused pure expression or super */ null && ([
    48,
    56
]));
const Input = /*#__PURE__*/ (0,react.forwardRef)((props, forwardedRef)=>{
    const { className, inputClassName, inputErrorClassName, id, field, size, label, note, mask, pattern, onFocus, onBlur, onChange, onChangeEvent, onKeyDown, withCross = false, withCheckmark = false, labelStyle = "p2", "data-testid": dataTestId = "input", withBorder = true, ...otherProps } = props;
    const intl = (0,useIntl/* default */.Z)();
    const inputRef = (0,react.useRef)(null);
    const combinedRef = (0,useCombinedRefs/* default */.Z)([
        inputRef,
        forwardedRef,
        field.props.ref
    ]);
    const [isFocused, setFocusedState] = (0,react.useState)(false);
    const { value, error } = (0,useFieldState/* default */.Z)(field);
    const modifyValue = (0,react.useCallback)((value)=>{
        const applyMask = masks[mask];
        if (typeof applyMask === "function") {
            value = applyMask(value);
        } else if (pattern) {
            const r = new RegExp(`[^${pattern}]+`, pattern.includes("p") ? "gui" : "gi");
            value = value.replace(r, "");
        }
        return value;
    }, [
        mask,
        pattern
    ]);
    const handleFocus = (0,react.useCallback)((event)=>{
        setFocusedState(true);
        if (typeof onFocus === "function") {
            onFocus(event);
        }
    }, [
        onFocus
    ]);
    const handleBlur = (0,react.useCallback)(async (event)=>{
        // @ts-ignore
        await field.validate();
        setFocusedState(false);
        if (typeof onBlur === "function") {
            onBlur(event);
        }
    }, [
        field,
        onBlur
    ]);
    const handleChange = (0,react.useCallback)((event)=>{
        let value = modifyValue(String(event.target.value));
        // Imagine we have input with mask: "XX/XX/XXX" for date. user can type incorrect
        // value in field: "11/A", in this case "A" will be removed from value and field.set
        // be called with value "11", previous value (before user type "A") was "11" - react
        // will not re-render the component, but native "uncontrolled" change in the input already
        // happened and user sees "11/A" in the input. To avoid this we need replace input's value manually.
        inputRef.current.value = value;
        field.set(value);
        if (typeof onChangeEvent === "function") {
            onChangeEvent(event);
        }
        if (typeof onChange === "function") {
            onChange(value);
        }
    }, [
        field,
        modifyValue,
        onChange,
        onChangeEvent
    ]);
    const handleClear = ()=>{
        const value = "";
        inputRef.current.value = value;
        field.set(value);
    };
    const isFilled = value !== "";
    const isErrored = Boolean(error);
    const isRequired = field.validators.includes(validators/* required */.C1);
    const rootClassName = (0,twcx/* twcx */.L)(Input_module.root, Input_module[`size-${size}`], {
        [Input_module.focused]: isFocused,
        [Input_module.filled]: isFilled,
        [Input_module.errored]: isErrored
    }, className);
    const labelClassName = (0,twcx.cx)(Input_module.label, Input_module[`label-${labelStyle}`]);
    const uniqueId = (0,useUniqueId/* default */.Z)("input-");
    const controlId = id || uniqueId;
    const htmlAttrs = (0,getGlobalHtmlAttrs/* default */.Z)(otherProps);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: rootClassName,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "relative",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("label", {
                        className: labelClassName,
                        htmlFor: controlId,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Message/* default */.Z, {
                            value: label
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                        ...htmlAttrs,
                        ref: combinedRef,
                        id: controlId,
                        className: (0,twcx/* twcx */.L)(Input_module.input, "w-full rounded bg-white text-black", withBorder ? "border-solid-gray-30" : "border-solid-white", inputClassName),
                        value: value,
                        placeholder: "",
                        onFocus: handleFocus,
                        onBlur: handleBlur,
                        onChange: handleChange,
                        onKeyDown: onKeyDown,
                        "data-testid": dataTestId,
                        "aria-invalid": isErrored,
                        "aria-required": isRequired
                    }),
                    withCheckmark && field.state.isValid && !isFocused && isFilled && /*#__PURE__*/ (0,jsx_runtime.jsx)(Icon/* default */.ZP, {
                        className: "absolute top-[65%] -translate-y-1/2 translate-x-full",
                        style: {
                            left: `${value.toString().length * 9}rem`
                        },
                        name: "16/checkmark-small",
                        color: "green"
                    }),
                    withCross && isFilled && /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                        className: (0,twcx.cx)("absolute cursor-pointer", Input_module.cross),
                        type: "button",
                        onClick: handleClear,
                        "aria-label": intl.formatMessage(messages.clear),
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Icon/* default */.ZP, {
                            name: "24/close"
                        })
                    })
                ]
            }),
            Boolean(note && !isErrored) && /*#__PURE__*/ (0,jsx_runtime.jsx)(InputNote/* default */.Z, {
                className: "mt-4",
                message: note,
                "data-testid": `${dataTestId}Note`
            }),
            isErrored && /*#__PURE__*/ (0,jsx_runtime.jsx)(InputError/* default */.Z, {
                className: (0,twcx/* twcx */.L)("mt-4", inputErrorClassName),
                message: error,
                "data-testid": `${dataTestId}Error`
            })
        ]
    });
});
Input.displayName = "Input";
/* harmony default export */ const Input_Input = (Input);


/***/ }),

/***/ 1324:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   Z: () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(97458);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(52983);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(78364);
/* harmony import */ var intl__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(927);




const InputError = (props)=>{
    const { className, message, "data-testid": dataTestId = "error" } = props;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: (0,classnames__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(className, "text-t3 text-red"),
        "data-testid": dataTestId,
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(intl__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
            value: message
        })
    });
};
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (InputError);


/***/ }),

/***/ 53927:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   Z: () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(97458);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(52983);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(78364);
/* harmony import */ var intl__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(927);




const InputNote = (props)=>{
    const { className, message, "data-testid": dataTestId } = props;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: (0,classnames__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(className, "text-t3 text-gray-80"),
        "data-testid": dataTestId,
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(intl__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
            value: message
        })
    });
};
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (InputNote);


/***/ }),

/***/ 95930:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  Z: () => (/* binding */ InputWithAutocomplete_InputWithAutocomplete)
});

// EXTERNAL MODULE: ../../node_modules/.pnpm/react@18.2.0/node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(97458);
// EXTERNAL MODULE: ../../node_modules/.pnpm/react@18.2.0/node_modules/react/index.js
var react = __webpack_require__(52983);
// EXTERNAL MODULE: ../../node_modules/.pnpm/@headlessui+react@1.7.18_react-dom@18.2.0_react@18.2.0/node_modules/@headlessui/react/dist/components/combobox/combobox.js + 7 modules
var combobox = __webpack_require__(35971);
// EXTERNAL MODULE: ./local_modules/formular/useFieldState.ts
var useFieldState = __webpack_require__(29987);
// EXTERNAL MODULE: ./src/components/inputs/Input/Input.tsx + 3 modules
var Input = __webpack_require__(26268);
// EXTERNAL MODULE: ./src/components/dataDisplay/Icon/Icon.tsx + 112 modules
var Icon = __webpack_require__(90234);
// EXTERNAL MODULE: ../../node_modules/.pnpm/clsx@2.1.0/node_modules/clsx/dist/clsx.mjs
var clsx = __webpack_require__(78364);
;// CONCATENATED MODULE: ./src/components/inputs/InputWithAutocomplete/components/Option/Option.tsx




const Option = (param)=>{
    let { value, children } = param;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(combobox/* Combobox */.h.Option, {
        value: value,
        className: (param)=>{
            let { active } = param;
            return (0,clsx/* default */.Z)("px-16 py-4", active && "bg-light-beige");
        },
        children: (props)=>/*#__PURE__*/ react.cloneElement(react.Children.only(children), props)
    });
};
/* harmony default export */ const Option_Option = (Option);

;// CONCATENATED MODULE: ./src/components/inputs/InputWithAutocomplete/InputWithAutocomplete.tsx







const InputWithAutocomplete = (props)=>{
    const { size = 48, field, label, onSelect, onChange, isFetching, children, inputTestId, containerTestId } = props;
    const { value } = (0,useFieldState/* default */.Z)(field);
    const options = (0,react.useMemo)(()=>{
        if (!isFetching && (children === null || children === void 0 ? void 0 : children.length) === 0) {
            return null;
        }
        if (isFetching) {
            return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "flex h-full items-center justify-center",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Icon/* default */.ZP, {
                    name: "20/loader"
                })
            });
        }
        return children;
    }, [
        isFetching,
        children
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(combobox/* Combobox */.h, {
        value: value,
        onChange: onSelect,
        // required to allow empty input without an option selected
        nullable: true,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "relative",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(combobox/* Combobox */.h.Input, {
                    as: InputWrapper,
                    label: label,
                    size: size,
                    field: field,
                    autoComplete: "off",
                    withCross: true,
                    onValueChange: onChange,
                    "data-testid": inputTestId
                }),
                Boolean(options) && /*#__PURE__*/ (0,jsx_runtime.jsx)(combobox/* Combobox */.h.Options, {
                    className: "absolute left-0 z-floating-header mt-12 max-h-[240rem] w-full overflow-y-auto rounded bg-white py-4 shadow",
                    "aria-busy": isFetching,
                    "data-testid": containerTestId,
                    children: options
                })
            ]
        })
    });
};
const InputWrapper = /*#__PURE__*/ (0,react.forwardRef)((props, ref)=>{
    const { onChange, onValueChange, ...rest } = props;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Input/* default */.Z, {
        ...rest,
        ref: ref,
        onChangeEvent: onChange,
        onChange: onValueChange
    });
});
InputWithAutocomplete.Option = Option_Option;
/* harmony default export */ const InputWithAutocomplete_InputWithAutocomplete = (InputWithAutocomplete);


/***/ }),

/***/ 38110:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  Z: () => (/* binding */ RadioGroup_RadioGroup)
});

// EXTERNAL MODULE: ../../node_modules/.pnpm/react@18.2.0/node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(97458);
// EXTERNAL MODULE: ../../node_modules/.pnpm/react@18.2.0/node_modules/react/index.js
var react = __webpack_require__(52983);
// EXTERNAL MODULE: ../../node_modules/.pnpm/@headlessui+react@1.7.18_react-dom@18.2.0_react@18.2.0/node_modules/@headlessui/react/dist/components/radio-group/radio-group.js + 2 modules
var radio_group = __webpack_require__(89370);
// EXTERNAL MODULE: ./local_modules/formular/useFieldState.ts
var useFieldState = __webpack_require__(29987);
// EXTERNAL MODULE: ./src/components/dataDisplay/Text/Text.tsx + 1 modules
var Text = __webpack_require__(78565);
// EXTERNAL MODULE: ../../node_modules/.pnpm/clsx@2.1.0/node_modules/clsx/dist/clsx.mjs
var clsx = __webpack_require__(78364);
;// CONCATENATED MODULE: ./src/components/inputs/RadioGroup/components/Option/Option.module.css
// extracted by mini-css-extract-plugin
/* harmony default export */ const Option_module = ({"root":"OyiEhn","disabled":"ZLM_A_"});
;// CONCATENATED MODULE: ./src/components/inputs/RadioGroup/components/Option/Option.tsx





const Option = (props)=>{
    const { className, value, children, disabled, "aria-label": ariaLabel, "data-testid": dataTestId } = props;
    const rootClassName = (0,clsx/* default */.Z)(className, Option_module.root, "group", {
        [Option_module.disabled]: disabled
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(radio_group/* RadioGroup */.E.Option, {
        className: rootClassName,
        value: value,
        disabled: disabled,
        "aria-label": ariaLabel,
        "data-testid": dataTestId,
        children: (props)=>/*#__PURE__*/ react.cloneElement(react.Children.only(children), props)
    });
};
/* harmony default export */ const Option_Option = (/*#__PURE__*/react.memo(Option));

;// CONCATENATED MODULE: ./src/components/inputs/RadioGroup/RadioGroup.tsx






const Component = (props)=>{
    const { children, className, field, label, "aria-label": ariaLabel, "data-testid": dataTestId, onChange } = props;
    const state = (0,useFieldState/* default */.Z)(field);
    const handleChange = (0,react.useCallback)((value)=>{
        field.set(value);
        if (typeof onChange === "function") {
            onChange(value);
        }
    }, [
        field,
        onChange
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(radio_group/* RadioGroup */.E, {
        className: className,
        value: state.value,
        "aria-label": ariaLabel,
        "data-testid": dataTestId,
        onChange: handleChange,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
            children: [
                Boolean(label) && /*#__PURE__*/ (0,jsx_runtime.jsx)(radio_group/* RadioGroup */.E.Label, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.ZP, {
                        message: label,
                        style: "p4",
                        color: "gray-80",
                        html: true
                    })
                }),
                children
            ]
        })
    });
};
const RadioGroup = /*#__PURE__*/ react.memo(Component);
RadioGroup.Option = Option_Option;
RadioGroup.Label = radio_group/* RadioGroup */.E.Label;
RadioGroup.Description = radio_group/* RadioGroup */.E.Description;
/* harmony default export */ const RadioGroup_RadioGroup = (RadioGroup);


/***/ }),

/***/ 19744:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   Z: () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* unused harmony export sizeToClassNameMap */
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(97458);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(52983);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(78364);
/* harmony import */ var intl__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(2129);
/* harmony import */ var components_dataDisplay__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(90234);
/* harmony import */ var components_inputs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(97127);






const sizeToClassNameMap = {
    32: "h-s32 w-s32",
    64: "h-s64 w-s64",
    72: "h-s72 w-s72"
};
const RoundButton = (props)=>{
    const { children, className, title, href, to, toTab, size, loading, disabled, onClick, "data-testid": dataTestId } = props;
    const intl = (0,intl__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)();
    const ariaLabel = intl.formatMessage(title);
    const rootClassName = (0,classnames__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)("rounded-full transition-all duration-200 ease-out", sizeToClassNameMap[size], {
        "cursor-not-allowed opacity-80 grayscale": disabled
    }, className);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_inputs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
        className: rootClassName,
        href: href,
        to: to,
        toTab: toTab,
        disabled: disabled,
        loading: loading,
        "aria-label": ariaLabel,
        onClick: onClick,
        "data-testid": dataTestId,
        children: loading ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_dataDisplay__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .ZP, {
            name: "32/loader",
            color: "gray-30"
        }) : children
    });
};
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (RoundButton);


/***/ }),

/***/ 6867:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  Z: () => (/* binding */ SearchInput_SearchInput)
});

// UNUSED EXPORTS: sizes

// EXTERNAL MODULE: ../../node_modules/.pnpm/react@18.2.0/node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(97458);
// EXTERNAL MODULE: ../../node_modules/.pnpm/react@18.2.0/node_modules/react/index.js
var react = __webpack_require__(52983);
// EXTERNAL MODULE: ../../node_modules/.pnpm/clsx@2.1.0/node_modules/clsx/dist/clsx.mjs
var clsx = __webpack_require__(78364);
// EXTERNAL MODULE: ./local_modules/intl/useIntl.ts
var useIntl = __webpack_require__(2129);
// EXTERNAL MODULE: ./local_modules/formular/useFieldState.ts
var useFieldState = __webpack_require__(29987);
// EXTERNAL MODULE: ./src/helpers/getters/getGlobalHtmlAttrs.ts
var getGlobalHtmlAttrs = __webpack_require__(614);
// EXTERNAL MODULE: ./src/components/inputs/Form/Form.tsx
var Form = __webpack_require__(55578);
;// CONCATENATED MODULE: ./src/components/inputs/SearchInput/SearchInput.module.css
// extracted by mini-css-extract-plugin
/* harmony default export */ const SearchInput_module = ({"input":"Ya84Sb","size-30":"aX_Dvn","size-34":"q0bBOH"});
;// CONCATENATED MODULE: ./src/components/inputs/SearchInput/SearchInput.tsx








const sizes = (/* unused pure expression or super */ null && ([
    30,
    34
]));
const SearchInput = (props)=>{
    const { field, size, placeholder, className, ...rest } = props;
    const { value } = (0,useFieldState/* default */.Z)(field);
    const intl = (0,useIntl/* default */.Z)();
    const placeholderString = (0,react.useMemo)(()=>intl.formatMessage(placeholder), [
        placeholder
    ]) // eslint-disable-line react-hooks/exhaustive-deps
    ;
    const inputRef = (0,react.useRef)(null);
    const handleChange = (event)=>field.set(event.target.value);
    const htmlAttrs = (0,getGlobalHtmlAttrs/* default */.Z)(rest);
    (0,react.useEffect)(()=>{
        var _inputRef_current;
        (_inputRef_current = inputRef.current) === null || _inputRef_current === void 0 ? void 0 : _inputRef_current.focus();
    }, []);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Form/* default */.Z, {
        className: className,
        action: ".",
        "data-cnstrc-search-form": true,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
            ...htmlAttrs,
            className: (0,clsx/* default */.Z)(SearchInput_module.input, SearchInput_module[`size-${size}`], "w-full text-black"),
            ref: inputRef,
            type: "search",
            value: value,
            onChange: handleChange,
            placeholder: placeholderString,
            "data-testid": "searchInput",
            "data-cnstrc-search-input": true,
            autoFocus: true
        })
    });
};
SearchInput.displayName = "SearchInput";
/* harmony default export */ const SearchInput_SearchInput = (SearchInput);


/***/ }),

/***/ 35331:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  Z: () => (/* binding */ Select_Select)
});

// UNUSED EXPORTS: sizes

// EXTERNAL MODULE: ../../node_modules/.pnpm/react@18.2.0/node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(97458);
// EXTERNAL MODULE: ../../node_modules/.pnpm/react@18.2.0/node_modules/react/index.js
var react = __webpack_require__(52983);
// EXTERNAL MODULE: ./local_modules/formular/useFieldState.ts
var useFieldState = __webpack_require__(29987);
// EXTERNAL MODULE: ./src/hooks/useCombinedRefs.ts
var useCombinedRefs = __webpack_require__(48245);
// EXTERNAL MODULE: ./src/hooks/useUniqueId.ts
var useUniqueId = __webpack_require__(91327);
// EXTERNAL MODULE: ./local_modules/intl/Message.tsx + 1 modules
var Message = __webpack_require__(927);
// EXTERNAL MODULE: ../../node_modules/.pnpm/clsx@2.1.0/node_modules/clsx/dist/clsx.mjs
var clsx = __webpack_require__(78364);
// EXTERNAL MODULE: ./src/helpers/getters/getGlobalHtmlAttrs.ts
var getGlobalHtmlAttrs = __webpack_require__(614);
// EXTERNAL MODULE: ./src/components/dataDisplay/Icon/Icon.tsx + 112 modules
var Icon = __webpack_require__(90234);
// EXTERNAL MODULE: ./src/components/inputs/InputNote/InputNote.tsx
var InputNote = __webpack_require__(53927);
// EXTERNAL MODULE: ./src/components/inputs/InputError/InputError.tsx
var InputError = __webpack_require__(1324);
;// CONCATENATED MODULE: ./src/components/inputs/Select/Select.module.css
// extracted by mini-css-extract-plugin
/* harmony default export */ const Select_module = ({"root":"AU2Zoz","focused":"b_es7j","selectContainer":"nm4YEC","errored":"_B4vX6","arrow":"TcUbdF","label":"aUiYQz","select":"Ltmydj","filled":"A05bdp","size-48":"JjsoCj","selectWithLabel":"cLpOsQ","selectNoLabel":"SfaIkV","size-56":"DycZS7"});
;// CONCATENATED MODULE: ./src/components/inputs/Select/Select.tsx











const sizes = (/* unused pure expression or super */ null && ([
    48,
    56
]));
const Select = /*#__PURE__*/ (0,react.forwardRef)((props, ref)=>{
    const { className, id, field, size, label, options, note, onFocus, onBlur, onChange, "data-testid": dataTestId = "input", ...otherProps } = props;
    const combinedRef = (0,useCombinedRefs/* default */.Z)([
        ref,
        field.props.ref
    ]);
    const [isFocused, setFocusedState] = (0,react.useState)(false);
    const { value, error } = (0,useFieldState/* default */.Z)(field);
    const handleFocus = (0,react.useCallback)((event)=>{
        setFocusedState(true);
        if (typeof onFocus === "function") {
            onFocus(event);
        }
    }, [
        onFocus
    ]);
    const handleBlur = (0,react.useCallback)((event)=>{
        setFocusedState(false);
        if (typeof onBlur === "function") {
            onBlur(event);
        }
    }, [
        onBlur
    ]);
    const handleChange = (0,react.useCallback)((event)=>{
        const value = event.target.value;
        field.set(value);
        if (typeof onChange === "function") {
            onChange(value);
        }
    }, [
        field,
        onChange
    ]);
    const uniqueId = (0,useUniqueId/* default */.Z)("select-");
    const controlId = id || uniqueId;
    const isFilled = value !== "" && value !== null;
    const isErrored = Boolean(error);
    const htmlAttrs = (0,getGlobalHtmlAttrs/* default */.Z)(otherProps);
    const rootClassName = (0,clsx/* default */.Z)(className, Select_module.root, Select_module[`size-${size}`], {
        [Select_module.focused]: isFocused,
        [Select_module.filled]: isFilled,
        [Select_module.errored]: isErrored
    });
    const withLabel = Boolean(label);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: rootClassName,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (0,clsx/* default */.Z)(Select_module.selectContainer, "border-solid-gray-30 relative rounded bg-white"),
                children: [
                    withLabel && /*#__PURE__*/ (0,jsx_runtime.jsx)("label", {
                        className: Select_module.label,
                        htmlFor: controlId,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Message/* default */.Z, {
                            value: label
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Icon/* default */.ZP, {
                        className: Select_module.arrow,
                        name: "32/arrow-down"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("select", {
                        ...htmlAttrs,
                        ref: combinedRef,
                        id: controlId,
                        className: (0,clsx/* default */.Z)(Select_module.select, withLabel ? Select_module.selectWithLabel : Select_module.selectNoLabel),
                        value: value,
                        onFocus: handleFocus,
                        onBlur: handleBlur,
                        onChange: handleChange,
                        "aria-invalid": isErrored,
                        "data-testid": dataTestId,
                        children: [
                            !value && /*#__PURE__*/ (0,jsx_runtime.jsx)("option", {
                                value: null
                            }),
                            options.map((param)=>{
                                let { title, value } = param;
                                return /*#__PURE__*/ (0,jsx_runtime.jsx)("option", {
                                    value: value,
                                    children: title
                                }, value);
                            })
                        ]
                    })
                ]
            }),
            Boolean(note && !isErrored) && /*#__PURE__*/ (0,jsx_runtime.jsx)(InputNote/* default */.Z, {
                className: "mt-4",
                message: note,
                "data-testid": `${dataTestId}Note`
            }),
            isErrored && /*#__PURE__*/ (0,jsx_runtime.jsx)(InputError/* default */.Z, {
                className: "mt-4",
                message: error,
                "data-testid": `${dataTestId}Error`
            })
        ]
    });
});
Select.displayName = "Select";
/* harmony default export */ const Select_Select = (/*#__PURE__*/react.memo(Select));


/***/ }),

/***/ 58961:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   Z: () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(97458);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(52983);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(78364);



const SelectableCardBase = (props)=>{
    const { children, className, isActive, disabled, onClick, "aria-label": ariaLabel, "data-testid": dataTestId } = props;
    if (typeof onClick === "function") {
        const rootClassName = (0,classnames__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(className, "w-full cursor-pointer rounded text-left", isActive ? "border-solid-gold-50" : "border-solid-gray-30 desktop-hover:border-gold-30");
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("button", {
            className: rootClassName,
            type: "button",
            onClick: onClick,
            disabled: disabled,
            "data-testid": dataTestId,
            "aria-selected": isActive,
            "aria-label": ariaLabel,
            children: children
        });
    }
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: (0,classnames__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(className, "border-solid-gray-30 rounded"),
        "data-testid": dataTestId,
        children: children
    });
};
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (SelectableCardBase);


/***/ }),

/***/ 99062:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   Z: () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(97458);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(52983);
/* harmony import */ var formular__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(29987);
/* harmony import */ var components_dataDisplay__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(88336);
/* harmony import */ var components_inputs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(1324);





const SelectableRating = (props)=>{
    const { className, field, size = 20, withHint = true, withError, hintPosition = "bottom", onChange } = props;
    const { value, error } = (0,formular__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(field);
    const handleChange = (0,react__WEBPACK_IMPORTED_MODULE_1__.useCallback)((value)=>{
        field.set(value);
        if (typeof onChange === "function") {
            onChange(value);
        }
    }, [
        field,
        onChange
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        className: className,
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_dataDisplay__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                value: value,
                size: size,
                withHint: withHint,
                hintPosition: hintPosition,
                onChange: handleChange
            }),
            Boolean(withError && error) && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_inputs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
                className: "mt-4",
                message: error
            })
        ]
    });
};
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (SelectableRating);


/***/ }),

/***/ 34167:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  Z: () => (/* binding */ Switch_Switch)
});

// UNUSED EXPORTS: sizes

// EXTERNAL MODULE: ../../node_modules/.pnpm/react@18.2.0/node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(97458);
// EXTERNAL MODULE: ../../node_modules/.pnpm/react@18.2.0/node_modules/react/index.js
var react = __webpack_require__(52983);
// EXTERNAL MODULE: ../../node_modules/.pnpm/@headlessui+react@1.7.18_react-dom@18.2.0_react@18.2.0/node_modules/@headlessui/react/dist/components/switch/switch.js
var switch_switch = __webpack_require__(21634);
// EXTERNAL MODULE: ./local_modules/formular/useFieldState.ts
var useFieldState = __webpack_require__(29987);
// EXTERNAL MODULE: ../../node_modules/.pnpm/clsx@2.1.0/node_modules/clsx/dist/clsx.mjs
var clsx = __webpack_require__(78364);
// EXTERNAL MODULE: ./src/helpers/getters/getGlobalHtmlAttrs.ts
var getGlobalHtmlAttrs = __webpack_require__(614);
;// CONCATENATED MODULE: ./src/components/inputs/Switch/Switch.module.css
// extracted by mini-css-extract-plugin
/* harmony default export */ const Switch_module = ({"switch":"GEsrMa","active":"vvfDqr","handle":"ENdWD7","size-30":"Q7lSJL"});
;// CONCATENATED MODULE: ./src/components/inputs/Switch/Switch.tsx







const sizes = (/* unused pure expression or super */ null && ([
    30
]));
const Component = (props)=>{
    const { field, size, style = "default", onChange, ...rest } = props;
    const { value } = (0,useFieldState/* default */.Z)(field);
    const globalHtmlAttrs = (0,getGlobalHtmlAttrs/* default */.Z)(rest);
    const handleChange = (value)=>{
        field.set(value);
        if (typeof onChange === "function") {
            onChange(value);
        }
    };
    const styleClassname = style === "default" ? (0,clsx/* default */.Z)("outline-none", value ? "bg-gold-30" : "bg-gray-50") : (0,clsx/* default */.Z)("outline outline-2 outline-gold-30", value ? "bg-gold-70" : "bg-pink");
    const rootClassName = (0,clsx/* default */.Z)("relative cursor-pointer", styleClassname, Switch_module[`size-${size}`], {
        [Switch_module.active]: value
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(switch_switch/* Switch */.r, {
        className: rootClassName,
        checked: value,
        onChange: handleChange,
        ...globalHtmlAttrs,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: Switch_module.handle
        })
    });
};
const Switch = /*#__PURE__*/ react.memo(Component);
Switch.Label = switch_switch/* Switch */.r.Label;
Switch.Group = switch_switch/* Switch */.r.Group;
/* harmony default export */ const Switch_Switch = (Switch);


/***/ }),

/***/ 17388:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  Z: () => (/* binding */ Textarea_Textarea)
});

// EXTERNAL MODULE: ../../node_modules/.pnpm/react@18.2.0/node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(97458);
// EXTERNAL MODULE: ../../node_modules/.pnpm/react@18.2.0/node_modules/react/index.js
var react = __webpack_require__(52983);
// EXTERNAL MODULE: ./local_modules/formular/useFieldState.ts
var useFieldState = __webpack_require__(29987);
// EXTERNAL MODULE: ./src/helpers/twcx.ts
var twcx = __webpack_require__(19460);
// EXTERNAL MODULE: ./local_modules/intl/useIntl.ts
var useIntl = __webpack_require__(2129);
// EXTERNAL MODULE: ./src/helpers/validators/index.ts + 1 modules
var validators = __webpack_require__(4894);
// EXTERNAL MODULE: ./src/helpers/getters/getGlobalHtmlAttrs.ts
var getGlobalHtmlAttrs = __webpack_require__(614);
// EXTERNAL MODULE: ./src/components/inputs/InputError/InputError.tsx
var InputError = __webpack_require__(1324);
// EXTERNAL MODULE: ../../node_modules/.pnpm/autosize@6.0.1/node_modules/autosize/dist/autosize.esm.js
var autosize_esm = __webpack_require__(95499);
;// CONCATENATED MODULE: ./src/components/inputs/Textarea/AutosizeTextarea.tsx



const UPDATE = "autosize:update";
const DESTROY = "autosize:destroy";
const RESIZED = "autosize:resized";
const AutosizeTextarea = /*#__PURE__*/ (0,react.forwardRef)((props, ref)=>{
    const { value, rows = 1, onResize, ...rest } = props;
    const textareaRef = (0,react.useRef)();
    const previousValueRef = (0,react.useRef)(value) // update from outside
    ;
    const setRef = (0,react.useCallback)((node)=>{
        textareaRef.current = node;
        if (typeof ref === "function") {
            ref(node);
        } else if (ref) {
            // @ts-ignore
            ref.current = node;
        }
    }, [
        ref
    ]);
    const dispatchEvent = (0,react.useCallback)((EVENT_TYPE, defer)=>{
        const event = document.createEvent("Event");
        event.initEvent(EVENT_TYPE, true, false);
        const dispatch = ()=>{
            if (textareaRef.current) {
                textareaRef.current.dispatchEvent(event);
            }
        };
        if (defer) {
            setTimeout(dispatch, 0);
        } else {
            dispatch();
        }
    }, []);
    (0,react.useEffect)(()=>{
        const textareaEl = textareaRef.current;
        (0,autosize_esm/* default */.Z)(textareaEl);
        if (typeof onResize === "function") {
            textareaEl.addEventListener(RESIZED, onResize);
        }
        return ()=>{
            if (typeof onResize === "function") {
                textareaEl.removeEventListener(RESIZED, onResize);
            }
            dispatchEvent(DESTROY);
        };
    }, [
        dispatchEvent,
        onResize
    ]);
    (0,react.useEffect)(()=>{
        if (previousValueRef.current !== value) {
            dispatchEvent(UPDATE, true);
            previousValueRef.current = value;
        }
    }, [
        dispatchEvent,
        value
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("textarea", {
        ref: setRef,
        value: value,
        rows: rows,
        ...rest
    });
});
/* harmony default export */ const Textarea_AutosizeTextarea = (AutosizeTextarea);

;// CONCATENATED MODULE: ./src/components/inputs/Textarea/Textarea.module.css
// extracted by mini-css-extract-plugin
/* harmony default export */ const Textarea_module = ({"textarea":"ta1XEH","standard":"lOfjjQ","errored":"MDVYh7"});
;// CONCATENATED MODULE: ./src/components/inputs/Textarea/Textarea.tsx










const Textarea = (props)=>{
    const { className, inputClassName, field, placeholder, rows = 4, plain, focusOnMount, onFocus, onBlur, onChange, onResize, onKeyDown, isResizable = true, withBorder = true, ...rest } = props;
    const intl = (0,useIntl/* default */.Z)();
    const ref = (0,react.useRef)();
    const { value, error } = (0,useFieldState/* default */.Z)(field);
    (0,react.useEffect)(()=>{
        if (focusOnMount && ref.current) {
            ref.current.focus();
        }
    }, []) // eslint-disable-line react-hooks/exhaustive-deps
    ;
    const handleBlur = (0,react.useCallback)(async (event)=>{
        // @ts-ignore
        await field.validate();
        if (typeof onBlur === "function") {
            onBlur(event);
        }
    }, [
        field,
        onBlur
    ]);
    const handleChange = (0,react.useCallback)((event)=>{
        const value = event.target.value;
        field.set(value);
        if (typeof onChange === "function") {
            onChange(value);
        }
    }, [
        field,
        onChange
    ]);
    const isErrored = Boolean(error);
    const textareaClassName = (0,twcx/* twcx */.L)(Textarea_module.textarea, "w-full bg-white text-black", {
        "rounded": !plain,
        "border-solid-gray-30": !plain && withBorder,
        "border-solid-white": !withBorder,
        [Textarea_module.standard]: !plain,
        [Textarea_module.errored]: isErrored
    }, inputClassName);
    const placeholderString = (0,react.useMemo)(()=>intl.formatMessage(placeholder), [
        placeholder
    ]) // eslint-disable-line react-hooks/exhaustive-deps
    ;
    const isRequired = field.validators.includes(validators/* required */.C1);
    const htmlAttrs = (0,getGlobalHtmlAttrs/* default */.Z)(rest);
    const textareaAttrs = {
        ...htmlAttrs,
        ref: ref,
        className: textareaClassName,
        value: value,
        placeholder: placeholderString,
        rows: rows,
        onFocus: onFocus,
        onBlur: handleBlur,
        onResize: onResize,
        onKeyDown: onKeyDown,
        onChange: handleChange,
        "aria-required": isRequired,
        "aria-multiline": true
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: className,
        children: [
            isResizable ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Textarea_AutosizeTextarea, {
                ...textareaAttrs
            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("textarea", {
                ...textareaAttrs
            }),
            isErrored && /*#__PURE__*/ (0,jsx_runtime.jsx)(InputError/* default */.Z, {
                className: "mt-4",
                message: error
            })
        ]
    });
};
/* harmony default export */ const Textarea_Textarea = (Textarea);


/***/ })

}]);